import React from "react";
import "./index.css";

const ProductContainer = ({ children }) => {
  return (
    <div className="product-detail-wrapper">
      <div className="product-detail-container">{children}</div>
    </div>
  );
};

export default ProductContainer;
